// src/api/contact.js
import axios from 'axios';

// 根据环境变量获取API基础URL
const API_BASE_URL = process.env.VUE_APP_API_BASE_URL;

// 创建axios实例
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

/**
 * 发送留言通知
 * @param {Object} data - 表单数据
 * @param {string} data.name - 姓名
 * @param {string} data.tel - 电话
 * @param {string} data.email - 邮箱（可选）
 * @param {string} data.content - 留言内容
 * @returns {Promise}
 */
export const sendNotification = (data) => {
  return apiClient.post('/send_notification', {
    name: data.name,
    tel: data.tel,
    email: data.email,
    content: data.content
  });
};